import { useState } from "react";
import styled from "styled-components";

const OneLineLabel = styled.div`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	cursor: pointer;
`;

const HoverBox = styled.div`
    border-radius: 8px;
    background-color: #E0E0E0;
    color: #424242;
    padding: 1rem;
    width: 50%;
    position: absolute;
    right: 19vw;
`;

const HoverText = ({ children }) => {
    const [isHover, setIsHover] = useState(false);

    const handleMouseOver = () => {
        setIsHover(true);
        console.log(`children.length: ${children.length}`);
    };

    const handleMouseOut = () => {
        setIsHover(false);
    };    

    return (
        <div
            onMouseOut={handleMouseOut}
        >
            {(isHover && children.length > 8) && <HoverBox>{children}</HoverBox>}
            <OneLineLabel
                onMouseOut={handleMouseOut}
                onMouseOver={handleMouseOver}
            >
                {children}
            </OneLineLabel>
        </div>
    )
};

export default HoverText;
